export const async_markup = async (text: string) => {
  const replacedText = await replaceAsync(text, /@tweet\[(.*?)\]/gim, (match: string, tweet_url: string) => FetchTweet(tweet_url))
  return replacedText
}

async function FetchTweet(tweet_url: any) {
  let url = process.env.NEXT_PUBLIC_BACKEND + 'general/tweet_oembed/?url=' + tweet_url
  const headers = {
    'Content-Type': 'application/json'
  }

  const res = await fetch(url, {method: 'GET', headers: headers})
  const json = await res.json()
  const result = await json.result
  return result.html
}

async function replaceAsync(str: string, regex: any, asyncFn: any) {
    const promises: any = [];
    str.replace(regex, (match, ...args) => {
        const promise = asyncFn(match, ...args);
        promises.push(promise);
        return match
    });
    const data: any = await Promise.all(promises);
    return str.replace(regex, () => data.shift());
}

export const excute_twitter_widget_script = () => {
  const head = document.getElementsByTagName('head')[0] as HTMLElement;
  const scriptUrl = document.createElement('script');
  scriptUrl.type = 'text/javascript';
  scriptUrl.src = 'https://platform.twitter.com/widgets.js';
  head.appendChild(scriptUrl);
}
